var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"load__box"},[_c('div',{staticClass:"loader-c"}),_c('p',{staticClass:"txt"},[_vm._v("Loading...")])])
}]

export { render, staticRenderFns }